import {
  Grid,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material';
import Iconify from 'src/components/iconify';

export const HoursTableView = ({ overtime, standard, employeeData }) => {
  console.log("🚀 ~ HoursTableView ~ employeeData:", employeeData);

  // Map days to match the format in the API response
  const daysMapping = {
    'Sunday': 'Sunday',
    'Monday': 'Monday',
    'Tuesday': 'Tuesday',
    'Wednesday': 'Wednesday',
    'Thursday': 'Thursday',
    'Friday': 'Friday',
    'Saturday': 'Saturday'
  };

  // Extract the weekly timesheet data from the employee data
  const weeklyTimeSheet = employeeData?.time_sheet?.weekly_time_sheet || [];
  
  // Create an object to store hours by day
  const dailyHours = {
    sunday: { standard: 0, overtime: 0 },
    monday: { standard: 0, overtime: 0 },
    tuesday: { standard: 0, overtime: 0 },
    wednesday: { standard: 0, overtime: 0 },
    thursday: { standard: 0, overtime: 0 },
    friday: { standard: 0, overtime: 0 },
    saturday: { standard: 0, overtime: 0 }
  };

  // Process the weekly timesheet data
  weeklyTimeSheet.forEach(dayData => {
    const dayName = dayData.day.toLowerCase();
    
    // Process entries for each day
    if (dayData.entries && dayData.entries.length > 0) {
      dayData.entries.forEach(entry => {
        const totalHours = entry.total_time_hours || 0;
        
        // Calculate standard and overtime hours
        if (totalHours <= 8) {
          dailyHours[dayName].standard += totalHours;
        } else {
          dailyHours[dayName].standard += 8;
          dailyHours[dayName].overtime += (totalHours - 8);
        }
      });
    }
  });

  const regularTimeRate = standard?.payRate || 0;
  const overTimeRate = overtime?.payRate || 0;
  
  const calculateTotalEarned = (hours, rate) => {
    return (hours * rate).toFixed(2);
  };
  
  const standardTotalEarned = calculateTotalEarned(standard.totalHours, regularTimeRate);
  const overtimeTotalEarned = calculateTotalEarned(overtime.totalHours, overTimeRate);

  // Get the employee's name
  const employeeName = `${employeeData.first_name || ''} ${employeeData.last_name || ''}`.trim();

  return (
    <Grid item xs={12}>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<Iconify icon="eva:arrow-ios-downward-fill" />}>
          <b>{employeeName || 'Hours Breakdown'}</b>
        </AccordionSummary>
        <AccordionDetails>
          <TableContainer component={Paper} variant="outlined">
            <Table size="small" sx={{ bgcolor: "#f5f5f5" }}>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '18px', color: 'black' }}>Day</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 'bold', fontSize: '16px', color: 'black' }}>
                    Standard Hours
                  </TableCell>
                  <TableCell align="right" sx={{ fontWeight: 'bold', fontSize: '16px', color: 'black' }}>
                    Overtime Hours
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.keys(daysMapping).map((day) => {
                  const dayKey = day.toLowerCase();
                  return (
                    <TableRow key={dayKey}>
                      <TableCell>{day}</TableCell>
                      <TableCell align="right">{dailyHours[dayKey].standard}</TableCell>
                      <TableCell align="right">{dailyHours[dayKey].overtime}</TableCell>
                    </TableRow>
                  );
                })}
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold' }}>Total Hours</TableCell>
                  <TableCell align="right">{standard.totalHours}</TableCell>
                  <TableCell align="right">{overtime.totalHours}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold' }}>Pay Rate</TableCell>
                  <TableCell align="right">${regularTimeRate}</TableCell>
                  <TableCell align="right">${overTimeRate}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold' }}>Total Earned</TableCell>
                  <TableCell align="right">${standardTotalEarned}</TableCell>
                  <TableCell align="right">${overtimeTotalEarned}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};